module.exports = __webpack_public_path__ + "static/media/sub1brpswidecalspoileraccy.96796f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sub1brpswidecalspoileraccy.png
// module id = 606
// module chunks = 0